import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SteeringGearService {

  SteeringPayLoad$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private occService: OccEndpointsService,) { }
  
  getYearDetails(productType){
    return this.http.get(this.occService.buildUrl(`products/fetchyears?productType=${productType}`));
  }
  getMakeDetails(productType,year){
    return this.http.get(this.occService.buildUrl(`products/fetchmakes?productType=${productType}&year=${year}`));
  }
  getModelDetails(productType,year,make){
    return this.http.get(this.occService.buildUrl(`products/fetchmodels?productType=${productType}&year=${year}&make=${make}`));
  }

  submitSteeringData(data,pageSize?, searchQuery?, currentPage?, sort?) {   
    return this.http.post(this.occService.buildUrl(`products/steering/searchresult?fields=FULL&pageSize=${pageSize}&currentPage=${currentPage}&query=${searchQuery}&sort=${sort}`),data);
  }

 
}
